import { z } from "zod";
import {
  localizedCitySeoSchema,
  localizedTextSchema,
  requiredLocalizedTextSchema,
  timestampsSchema,
} from "./common";
import { listQueryBaseSchema } from "./list-query";
import { mediaDtoSchema } from "./media";

export const cityDtoSchema = z
  .object({
    id: z.string().uuid(),
    countryId: z.string().uuid(),
    country: z.object({ id: z.string().uuid(), name: localizedTextSchema }).nullable(),
    name: localizedTextSchema,
    slug: z.string().nullable(),
    latitude: z.string(),
    longitude: z.string(),
    textColor: z.string().nullable(),
    backgroundColor: z.string().nullable(),
    imageMedia: mediaDtoSchema.nullable().optional(),
    activitiesCount: z.number().int().nonnegative().optional(),
    combosCount: z.number().int().nonnegative().optional(),
    seo: localizedCitySeoSchema.optional(),
  })
  .extend(timestampsSchema.shape);
export type CityDTO = z.infer<typeof cityDtoSchema>;

export const cityUpsertSchema = z.object({
  countryId: z.string().uuid(),
  name: requiredLocalizedTextSchema,
  slug: z.string().min(1).optional(),
  latitude: z.string().min(1),
  longitude: z.string().min(1),
  textColor: z.string().optional(),
  backgroundColor: z.string().optional(),
  seo: localizedCitySeoSchema.optional(),
});
export type CityUpsertInput = z.infer<typeof cityUpsertSchema>;

export const citiesListQuerySchema = listQueryBaseSchema.extend({
  countryId: z.string().uuid().optional(),
});
export type CitiesListQuery = z.infer<typeof citiesListQuerySchema>;
